// extracted by mini-css-extract-plugin
module.exports = {"list":"projects_list__j5vJS","logo":"projects_logo__LNW8m"};